// Libs
import { TFunction } from 'i18next';
import * as yup from 'yup';
// Others
import { DEFAULT_NUMBER_ONE, EMPTY_STRING, MAX_SIZE_FILE_UPLOAD } from '~/utils/constants/common';
import { IFormDocument } from '~/utils/interface/document';
import { mimeTypes } from '~/utils/mockData/document';

export const schema = (t: TFunction) => {
  return yup
    .object()
    .shape({
      files: yup
        .array()
        .of(
          yup.object().shape({
            id: yup.string().trim().optional(),
            name: yup
              .string()
              .trim()
              .required(t('common_validate_field_required', { ns: 'common/base' })),
            url: yup.string().trim().optional(),
            file: yup
              .mixed<File>()
              .required(t('common_validate_field_required', { ns: 'common/base' }))
              .test('fileSize', t('common_validate_file_size', { ns: 'common/base' }), (value) => {
                if (!value) return true;
                if (value && value?.size <= MAX_SIZE_FILE_UPLOAD) return true;
                return false;
              }),
          })
        )
        .min(DEFAULT_NUMBER_ONE, t('common_validate_field_required', { ns: 'common/base' }))
        .required(t('common_validate_field_required', { ns: 'common/base' })),
      folder: yup
        .string()
        .trim()
        .required(t('common_validate_field_required', { ns: 'common/base' })),
    })
    .required();
};

export const defaultValuesForm: IFormDocument = {
  files: [],
  folder: EMPTY_STRING,
};

/**
 * Retrieves the file extension corresponding to a given MIME type.
 * @param {string} mimeType - The MIME type for which to get the file extension.
 * @returns {string} The file extension including a dot prefix (e.g., ".jpg") or a default value if unknown.
 */
export const getFileExtensionFromMimeType = (mimeType: string): string => {
  const type = `.${mimeTypes[mimeType]}`;
  return type || EMPTY_STRING;
};
